import React from 'react';
import { FastField } from 'formik';
import PropTypes from 'prop-types';

import InputAdornment from '@mui/material/InputAdornment';
import LockOutlined from '@mui/icons-material/LockOutlined';

import { CommonInlineInputDiv } from '../common/form/style';
import RenderTextField from '../common/RenderTextField';
import { HalfWidth } from '../common/style';

import { validateConfirmPassword, validatePassword } from '../../utils/validators';

const CommonPasswordFields = ({ inline, withoutIcons, changePassword }) => {

  const passwordField = (
    <FastField
      name="password"  // Directly bind the field name to Formik
      type="password"
      component={RenderTextField}
      label="Hasło"
      InputProps={{
        startAdornment: !withoutIcons && (
          <InputAdornment position="start">
            <LockOutlined />
          </InputAdornment>
        )
      }}
//       validate={validatePassword}
    />
  );

  const repeatPasswordField = (
    <FastField
      name={changePassword ? 'newPassword' : 'repeatPassword'}  // Same for repeatPassword
      type="password"
      component={RenderTextField}
      label="Powtórz hasło"
      InputProps={{
        startAdornment: !withoutIcons && (
          <InputAdornment position="start">
            <LockOutlined />
          </InputAdornment>
        )
      }}
//       validate={validateConfirmPassword}
    />
  );

  if (inline) {
    return (
      <CommonInlineInputDiv>
        <HalfWidth>
          {passwordField}
        </HalfWidth>

        <HalfWidth>
          {repeatPasswordField}
        </HalfWidth>
      </CommonInlineInputDiv>
    );
  }

  return (
    <React.Fragment>
      {passwordField}
      {repeatPasswordField}
    </React.Fragment>
  );
};

CommonPasswordFields.propTypes = {
  inline: PropTypes.bool,
  withoutIcons: PropTypes.bool,
  changePassword: PropTypes.bool,
};

export default CommonPasswordFields;
